module.exports = __webpack_public_path__ + "static/img/cert4.bbbbdeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert4.png
// module id = TOp8
// module chunks = 1